import { styled } from "@linaria/react"

import { pluralize } from "@/lib/displayUtils.ts"

type DiffSizeProps = {
  added: number
  deleted: number
  verbose?: boolean
}

const AddedLines = styled.span`
  color: var(--success-color);
`

const DeletedLines = styled.span`
  color: var(--error-color);
`

const DiffSizeContainer = styled.span`
  white-space: nowrap;
`

export const DiffSize = ({ added, deleted, verbose }: DiffSizeProps) => {
  return (
    <DiffSizeContainer>
      {added > 0 && (
        <AddedLines title={`${added} ${pluralize("line", added)} added`}>
          {!verbose ? `+${added}` : `${added} ${pluralize("addition", added)}`}
        </AddedLines>
      )}

      {added > 0 && deleted > 0 && (
        !verbose ? <>&nbsp;</> : <>&ensp;</>
      )}

      {deleted > 0 && (
        <DeletedLines title={`${deleted} ${pluralize("line", deleted)} deleted`}>
          {!verbose ? `−${deleted}` : `${deleted} ${pluralize("deletion", deleted)}`}
        </DeletedLines>
      )}
    </DiffSizeContainer>
  )
}